export default function Tabs({
  tabs = [],
  activeTab,
  onChange,
  variant = 'default', // 'default' | 'pills'
  className = '',
}) {
  return (
    <div className={`tabs ${variant === 'pills' ? 'tabs--pills' : ''} ${className}`}>
      {tabs.map((tab) => {
        const Icon = tab.icon;
        const isActive = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            className={`tabs__item ${isActive ? 'tabs__item--active' : ''}`}
            onClick={() => onChange(tab.id)}
          >
            {Icon && <Icon size={16} />}
            <span>{tab.label}</span>
            {tab.badge !== undefined && <span className="tabs__badge">({tab.badge})</span>}
          </button>
        );
      })}
    </div>
  );
}
